import React from 'react';
import { FormGroup } from 'reactstrap';
import InputPasswordToggle from '@components/input-password-toggle';
import HelperText from '../@core/components/helper-text';
import { Label } from './Forms';

const InputPassword = ({
	caption,
	onChange,
	value,
	disabled,
	placeholder,
	name,
	maxLength,
	isRequired,
	onBlur,
	invalid,
	errors,
	className,
	inputProps,
	noInputWrapper,
	...other
}) => {
	return (
		<FormGroup {...other}>
			<div className="d-flex justify-content-between">
				<Label className="form-label " for="login-password">
					{caption}
					{isRequired && <span style={{ color: '#0DB944' }}>*</span>}
				</Label>
			</div>
			<InputPasswordToggle
				name={name}
				errors={errors}
				onChange={onChange}
				onBlur={onBlur}
				value={value}
				disabled={disabled}
				invalid={errors && true}
				{...inputProps}
			/>
			<HelperText error={errors} />
		</FormGroup>
	);
};

export default InputPassword;
